import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PartnerService } from '../partner-management/partner.service';
import { HelperService } from 'app/core/services/helper/helper.service';
import { environment } from 'environments/environment.prod';

@Component({
  selector: 'app-shopify-connection',
  standalone: true,
  imports: [],
  templateUrl: './shopify-connection.component.html',
  styleUrl: './shopify-connection.component.scss'
})
export class ShopifyConnectionComponent {
    constructor(private route: ActivatedRoute, private _router: Router, private _apiService: PartnerService, public _helper: HelperService){
      this.route.queryParams.subscribe(params => {
      const code = params['code'];
      const shop = params['shop'];
      const pId = this._helper.getLocalStorageData('P_ID');

      let reqData = {
        shop: shop,
        code: code,
        partnerId: pId
      }
      this._apiService.addEdit(reqData).subscribe(
                (res: any) => {
                    if (res?.meta?.status === 1) {
                        this._helper.toast(res.meta.message, 'success');
                        this._helper.removeLocalStorageData('P_ID');
                        this.goBack();
                    } else {
                        this._helper.toast(res.meta.message, 'error');
                    }
                },
            );
    });
    }

    goBack(){
      environment.production ? this._router.navigate(['/dashboard']) : this._router.navigate(['partner/dashboard'])
    }
}
